import {
	Addchart,
	AddCircle,
	AutoAwesome,
	Category,
	Collections,
	CrisisAlertRounded,
	DashboardOutlined,
	EmojiEvents,
	Inventory,
	ListAltRounded,
	LocalMallOutlined,
	Loyalty,
	MilitaryTech,
	MiscellaneousServices,
	PeopleAlt,
	Search,
	ShoppingBasket,
	Store,
	Storefront,
	ViewModule,
	VpnKey,
} from "@mui/icons-material";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";

export const appMenuItems = [
	{
		name: "Dashboard",
		link: "/w86zjruk6q",
		slu: "/w86zjruk6q",
		Icon: DashboardOutlined,
	},

	{
		name: "Insights",
		link: "/w86zjruk6q/insights",
		slu: "/w86zjruk6q/insights",
		Icon: AutoAwesome,
	},

	{
		name: "AI Search",
		link: "/w86zjruk6q/search/ai",
		slu: "/w86zjruk6q/search/ai",
		Icon: Search,
	},

	{
		name: "API Keys",
		link: "/w86zjruk6q/search/api-keys",
		slu: "/w86zjruk6q/search/api-keys",
		Icon: VpnKey,
	},

	{
		name: "Users",
		link: "/w86zjruk6q/user",
		slu: "/w86zjruk6q/user",
		Icon: PeopleAlt,
	},

	{
		name: "Catalogs",
		Icon: Storefront,
		slu: "/w86zjruk6q/catalog",
		items: [
			{
				name: "Brand",
				link: "/w86zjruk6q/brand",
				slu: "/w86zjruk6q/brand",
				Icon: LocalMallOutlined,
			},
			{
				name: "List Categories",
				link: "/w86zjruk6q/listcategories",
				slu: "/w86zjruk6q/listcategories",
				Icon: Loyalty,
			},
			{
				name: "Product Categories",
				link: "/w86zjruk6q/product-category",
				slu: "/w86zjruk6q/product-category",
				Icon: Category,
			},
			{
				name: "Products",
				link: "/w86zjruk6q/product",
				slu: "/w86zjruk6q/product",
				Icon: LocalMallOutlined,
			},
			{
				name: "Sellers",
				link: "/w86zjruk6q/seller",
				slu: "/w86zjruk6q/seller",
				Icon: Store,
			},
		],
	},

	{
		name: "Add",
		link: "/w86zjruk6q/add",
		slu: "/w86zjruk6q/add",
		Icon: AddCircle,
		items: [
			{
				name: "Add Grapelist",
				link: "/w86zjruk6q/grapelist/add",
				Icon: LocalMallOutlined,
			},
			{
				name: "Add Persistent List",
				link: "/w86zjruk6q/persistent-list/add",
				Icon: LocalMallOutlined,
			},
			{
				name: "Add Playoff",
				link: "/w86zjruk6q/playoff/add",
				Icon: LocalMallOutlined,
			},
			{
				name: "Add Curation",
				link: "/w86zjruk6q/curation/add",
				Icon: LocalMallOutlined,
			},
		],
	},

	{
		name: "Playoff",
		Icon: EmojiEvents,
		slu: "/w86zjruk6q/playoff",
		items: [
			{
				name: "Playoffs",
				link: "/w86zjruk6q/playoff",
				Icon: MilitaryTech,
			},
			{
				name: "PlayOff Buckets",
				link: "/w86zjruk6q/buckets",
				Icon: ViewModule,
			},
			{
				name: "Curations",
				link: "/w86zjruk6q/curation",
				Icon: CrisisAlertRounded,
			},
		],
	},

	{
		name: "Popup",
		Icon: Collections,
		slu: "/w86zjruk6q/popup",
		items: [
			{
				name: "Buckets",
				link: "/w86zjruk6q/popup/collections",
				slu: "/w86zjruk6q/popup/collections",
				Icon: ViewModule,
			},
		],
	},

	{
		name: "Promotions",
		Icon: LocalMallOutlined,
		slu: "/w86zjruk6q/promotions",
		items: [
			{
				name: "Offers",
				link: "/w86zjruk6q/offers",
				slu: "/w86zjruk6q/offers",
				Icon: LocalMallOutlined,
			},
			{
				name: "Vouchers",
				link: "/w86zjruk6q/vouchers",
				slu: "/w86zjruk6q/vouchers",
				Icon: Loyalty,
			},
		],
	},

	{
		name: "Ordering",
		link: "/w86zjruk6q/ordering",
		slu: "/w86zjruk6q/ordering",
		Icon: CrisisAlertRounded,
	},

	{
		name: "Lists",
		link: "/w86zjruk6q/list",
		slu: "/w86zjruk6q/list",
		Icon: ListAltRounded,
		items: [
			{
				name: "Grape List",
				link: "/w86zjruk6q/grapelist",
				Icon: LocalMallOutlined,
			},
			{
				name: "Persistent List",
				link: "/w86zjruk6q/persistent-list",
				Icon: LocalMallOutlined,
			},
		],
	},

	{
		name: "Universal Cart",
		Icon: Storefront,
		slu: "/w86zjruk6q/cart",
		items: [
			{
				name: "Products",
				link: "/w86zjruk6q/cart/products",
				slu: "/w86zjruk6q/cart/products",
				Icon: Inventory,
			},
			{
				name: "All Playoffs",
				link: "/w86zjruk6q/cart/playoffs",
				slu: "/w86zjruk6q/cart/playoffs",
				Icon: LocalMallOutlined,
			},
			{
				name: "Add Playoff",
				link: "/w86zjruk6q/cart/playoff/add",
				slu: "/w86zjruk6q/cart/playoff/add",
				Icon: LocalMallOutlined,
			},
			{
				name: "Orders",
				link: "/w86zjruk6q/cart/orders",
				slu: "/w86zjruk6q/cart/orders",
				Icon: LocalMallOutlined,
			},
			{
				name: "AI Orders",
				link: "/w86zjruk6q/ai-orders",
				slu: "/w86zjruk6q/ai-orders",
				Icon: LocalMallOutlined,
			},
		],
	},

	{
		name: "Miscellaneous",
		link: "/w86zjruk6q/misc",
		slu: "/w86zjruk6q/misc",
		Icon: MiscellaneousServices,
		items: [
			{
				name: "Curator Count",
				link: "/w86zjruk6q/details",
				slu: "/w86zjruk6q/details",
				Icon: Addchart,
			},
			{
				name: "Waitlist",
				link: "/w86zjruk6q/waitlist",
				slu: "/w86zjruk6q/waitlist",
				Icon: AccessTimeOutlinedIcon,
			},
		],
	},

	{
		name: "Logs",
		Icon: MiscellaneousServices,
		slu: "/w86zjruk6q/logs",
		items: [
			{
				name: "Scraper Logs",
				link: "/w86zjruk6q/scraper_logs",
				slu: "/w86zjruk6q/scraper_logs",
				Icon: Addchart,
			},
			{
				name: "Product Logs",
				link: "/w86zjruk6q/product_logs",
				slu: "/w86zjruk6q/product_logs",
				Icon: AccessTimeOutlinedIcon,
			},
		],
	},
];

export const appMenuItemsForRestrictedUser = [
	{
		name: "Product",
		link: "/upload-playoff/product",
		slu: "/upload-playoff/product",
		Icon: Inventory,
	},

	{
		name: "Brand",
		link: "/upload-playoff/brand",
		slu: "/upload-playoff/brand",
		Icon: LocalMallOutlined,
	},

	{
		name: "Playoff",
		Icon: ShoppingBasket,
		slu: "/upload-playoff/playoff",
		items: [
			{
				name: "Playoffs",
				link: "/upload-playoff/playoff",
				Icon: LocalMallOutlined,
			},
			{
				name: "Add Playoff",
				link: "/upload-playoff/playoff/add",
				Icon: LocalMallOutlined,
			},
		],
	},
	{
		name: "Lists",
		link: "/upload-playoff/list",
		slu: "/upload-playoff/list",
		Icon: ListAltRounded,
		items: [
			{
				name: "Grape List",
				link: "/upload-playoff/grapelist",
				Icon: LocalMallOutlined,
			},
			{
				name: "Persistent List",
				link: "/upload-playoff/persistent-list",
				Icon: LocalMallOutlined,
			},
		],
	},

	{
		name: "Universal Cart",
		Icon: Storefront,
		slu: "/upload-playoff/cart",
		items: [
			{
				name: "Products",
				link: "/upload-playoff/cart/products",
				slu: "/upload-playoff/cart/products",
				Icon: Inventory,
			},
			{
				name: "All Playoffs",
				link: "/upload-playoff/cart/playoffs",
				slu: "/upload-playoff/cart/playoffs",
				Icon: LocalMallOutlined,
			},
			{
				name: "Add Playoff",
				link: "/upload-playoff/cart/playoff/add",
				slu: "/upload-playoff/cart/playoff/add",
				Icon: LocalMallOutlined,
			},
		],
	},
];
